import React, { useState } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import CartoonButton from '../../CartoonButton.component';
import { SubmittedBadge, labelStyle } from './ClosestNumber.game';
import { MinigameStateSnapshot } from '../../../shared/events';

interface Props {
  minigame: MinigameStateSnapshot;
  submitted: boolean;
  onSubmit: (answer: number) => void;
}

const NumberQuestion: React.FC<Props> = ({ minigame, submitted, onSubmit }) => {
  const [value, setValue] = useState('');
  const parsed = parseInt(value, 10);
  const valid = !isNaN(parsed) && parsed >= 0;

  if (submitted) return <SubmittedBadge label={`You answered ${value}`} />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 400 }}>
      <Box sx={{ background: 'rgba(255,255,255,0.15)', borderRadius: '16px', p: 2, border: '2px solid rgba(255,255,255,0.2)', width: '100%' }}>
        <Typography sx={{ ...labelStyle, fontSize: '1.05rem' }}>
          {minigame.question}
        </Typography>

      </Box>
      <TextField
        type="number"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' && valid) onSubmit(parsed); }}
        placeholder="Your answer…"
        inputProps={{ min: 0 }}
        sx={{ background: 'rgba(255,255,255,0.9)', borderRadius: '12px', width: '100%' }}
        autoFocus
      />
      <CartoonButton variant="contained" onClick={() => onSubmit(parsed)} disabled={!valid} sx={{ background: '#9c27b0' }}>
        Submit
      </CartoonButton>
    </Box>
  );
};

export default NumberQuestion;
